require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-selena-and-disa-the-mother-daughter-pair-learning-to-code-together.json") })
        }
      }, "path---blog-meet-selena-and-disa-the-mother-daughter-pair-learning-to-code-together");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-selena-and-disa-the-mother-daughter-pair-learning-to-code-together!./.cache/json/blog-meet-selena-and-disa-the-mother-daughter-pair-learning-to-code-together.json
// module id = 952
// module chunks = 231608221292675